import React from "react";

import { Search } from "lucide-react";

interface WorkspaceSearchProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
  disabled?: boolean;
}

const WorkspaceSearch: React.FC<WorkspaceSearchProps> = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  disabled = false,
}) => (
  <div className="library-search">
    <Search className="library-search__icon" aria-hidden />
    <input
      type="text"
      role="searchbox"
      className="library-search__input"
      placeholder={placeholder}
      value={value}
      onChange={e => onChange(e.target.value)}
      aria-label={ariaLabel}
      disabled={disabled}
    />
  </div>
);

export default WorkspaceSearch;
